import { render, staticRenderFns } from "./FinanceReadOnlyPanel.vue?vue&type=template&id=665d8f70"
import script from "./FinanceReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./FinanceReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports